import React from 'react';
import paginationPreviousDisabled from '../assets/images/pagination-previous-disabled.svg';

export default () => {
  return <img src={paginationPreviousDisabled} alt="Previous Page Disabled" />;
};
